/**
 * 联系人信息
 * @author Created by jiamei.yao 2017/05/22
 */

'use strict';
import React, { Component } from 'react';
import {View, Text, TouchableOpacity, Animated, TouchableWithoutFeedback} from 'react-native';
import Icon from '../../../../components/Icon';
import { observer, inject } from 'mobx-react';
import styles from './style';
import {getQueryParam} from "../../../../models/search/util";
import {scroll} from '../../../../common/utils';
import {isQunarApp} from "../../../../common/hysdkUtils/env";
import ReactDom from 'react-dom';
@inject(stores => {
    const {lowPriceDataStore, searchDataStore} = stores,
        {
            tabFixed,
            setFilter,
            setLocation,
            lowPriceData,
            selectedFilter,
            lowPriceDepCity,
            setLowPriceDepCity,
            handleFixedSearchBox,
            fixedSearchBoxVisible,
            handleSearchFilterModal
        } = lowPriceDataStore,
        {depCityListComp} = searchDataStore,
        {filters} = lowPriceData;
    return {
        tabFixed,
        selectedFilter,
        setLocation,
        filters,
        setFilter,
        handleSearchFilterModal,
        setLowPriceDepCity,
        depCityListComp,
        lowPriceDepCity,
        fixedSearchBoxVisible,
        handleFixedSearchBox
    };
})

@observer
class SearchBar extends Component {
    constructor(props) {
        super(props);

    }

    onPressLocation = () => {
        this.props.depCityListComp.show({
            selectedCityList: [{ name: this.props.lowPriceDepCity }],
            successCallback: (data) => {
                let result = data && data[0];
                let { search, name } = result;
                scroll(ReactDom.findDOMNode(this.props.scrollRef), this.props.scrollTop + 1);
                setTimeout(()=>{
                    this.props.setLowPriceDepCity(search || name);
                }, 450)
            }
        })
        GodEye.log({
            r: 'topfix_location_click'
        })
    };

    handleFixedSearchBox = (type) => {
        this.props.handleFixedSearchBox(type);

        GodEye.log({
            r: 'js_search_mask_click',
            type: type
        })

    }

    goBack = () => {
        if (hysdk.sniff.qunar) {
            const interceptBack = getQueryParam('interceptBack');
            if (isQunarApp() && interceptBack ==='true') {
                hysdk.event.sendEvent({
                    name: 'flight-tabBar-back',
                    success: function (res) {},
                    fail: function () {
                        GodEye.log({
                            r: 'flight_searchBar_back_fail'
                        });
                    }
                });
            } else {
                hysdk.closeWebView();
            }
        } else {
            history.go(-1);
        }
    };

    render() {
        let {selectedFilter, lowPriceDepCity, fixedSearchBoxVisible, isHideBack} = this.props || {};
        return (
            <Animated.View style={[styles.searchBarWrapper, {opacity: this.props.opacity}]}>
                <TouchableWithoutFeedback>
                    {isHideBack() ? <Icon name='' color='#333333' size={24} /> :  <Icon name='back' color='#333333' size={24} onPress={this.goBack} />}
                </TouchableWithoutFeedback>
                {fixedSearchBoxVisible
                    ? <View><Text style={styles.searchBarBigText}>搜索低价机票</Text></View>
                    : <View style={styles.searchBar}>
                        <TouchableOpacity style={styles.searchBarItem} onPress={()=>{
                            this.props.handleSearchFilterModal('show');
                            GodEye.log({
                                r: 'topfix_filter_click'
                            })
                        }}>
                            <Text style={styles.searchBarText}>{selectedFilter}</Text>
                            <Icon name='down' color='#333333' size={6} style={styles.searchBarIcon} />
                        </TouchableOpacity>
                        <View style={styles.searchBarLine} />
                        <TouchableOpacity style={styles.searchBarItem} onPress={this.onPressLocation}>
                            <Text style={[styles.searchBarText,{maxWidth: 56}]} numberOfLines={1} ellipsizeMode={'tail'}>{lowPriceDepCity}</Text>
                            <Text style={styles.searchBarText}>出发</Text>
                            <Icon name='down' color='#333333' size={6} style={styles.searchBarIcon} />
                        </TouchableOpacity>
                    </View>
                }

                {fixedSearchBoxVisible
                    ? <TouchableOpacity style={styles.searchBoxClose} onPress={this.handleFixedSearchBox}>
                        <Text>收起</Text>
                        <Icon name='down' color='#333333' size={6} style={styles.searchBoxUp}/>
                    </TouchableOpacity>
                    : <TouchableOpacity onPress={() => {
                        this.handleFixedSearchBox('show')
                    }}>
                        <Icon name='loupe' color='#333333' size={24} style={styles.loupe}/>
                    </TouchableOpacity>
                }
            </Animated.View>
        )
    }
}

export default SearchBar;
